module.exports = __webpack_public_path__ + "img/print-bg.c14f69cb.png";